module.exports = __webpack_public_path__ + "static/media/third-man-phone.d87546d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/third-man-phone.jpg
// module id = 2432
// module chunks = 0